import '../ui/styles.css';
import { createStore } from '../core/store';
import { EventBus } from '../core/event-bus';
import { createLazyTextFilter } from '../core/text-filter';
import { loadBannedWords } from '../content';
import { probeLocalStorage, SaveService } from '../save/service';
import { mountUi } from '../ui/mount';
import { bindSplash } from '../ui/splash';

function hasWebGL2(): boolean {
  try {
    const gl = document.createElement('canvas').getContext('webgl2');
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
    return !!gl;
  } catch {
    return false;
  }
}

const params = new URLSearchParams(location.search);
const store = createStore();
const bus = new EventBus();
const save = new SaveService(probeLocalStorage(), { onChange: () => bus.emit('save:changed') });
save.attachLifecycle(window);

store.persistent.value = save.persistent;
store.playerName.value = save.data.profile.name;
store.muted.value = save.data.settings.muted;
store.quality.value = save.data.settings.quality;
store.touch.value = matchMedia('(pointer: coarse)').matches;


const sessionStart = Date.now();
void import('../core/visitor-count').then(({ simulatedVisitors }) => {
  const refreshCounter = (): void => {
    const minutes = (Date.now() - sessionStart) / 60_000;
    store.visitorCount.value = simulatedVisitors(new Date()) + Math.floor(minutes * 3);
  };
  refreshCounter();
  setInterval(refreshCounter, 10_000);
});

bus.on('ui:enter', () => {
  const today = new Date().toISOString().slice(0, 10);
  if (save.data.stats.lastVisitDate === today) return;
  save.update((d) => {
    d.stats.visits += 1;
    d.stats.lastVisitDate = today;
  });
});

if (import.meta.env.PROD && 'serviceWorker' in navigator)
  addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });

const filter = createLazyTextFilter(loadBannedWords());
const uiRoot = document.getElementById('ui');
const gameRoot = document.getElementById('game');
const activityLayer = document.getElementById('activity-ui');
if (uiRoot) mountUi(uiRoot, { store, bus, save, filter });
bindSplash(store, bus);

if (!hasWebGL2() || !gameRoot || !activityLayer) {
  store.loadState.value = 'no-webgl';
} else {
  import('./game')
    .then(({ startGame }) =>
      startGame({
        container: gameRoot,
        store,
        bus,
        save,
        filter,
        activityLayer,
        debug: params.get('debug') === '1',
        seed: Number(params.get('seed')) || undefined,
      }),
    )
    .catch((err: unknown) => {
      console.error(err);
      store.loadState.value = 'error';
    });
}
